import { render, staticRenderFns } from "./GalleryThumbnailActionButton.vue?vue&type=template&id=f462cb9c&scoped=true"
import script from "./GalleryThumbnailActionButton.vue?vue&type=script&lang=ts"
export * from "./GalleryThumbnailActionButton.vue?vue&type=script&lang=ts"
import style0 from "./GalleryThumbnailActionButton.vue?vue&type=style&index=0&id=f462cb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f462cb9c",
  null
  
)

export default component.exports